/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/site/site.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { SiteRoutingModule } from "./site-routing.module";
import * as i0 from "@angular/core";
export class SiteModule {
    constructor() {
    }
}
SiteModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SiteRoutingModule,
                ],
            },] },
];
/** @nocollapse */
SiteModule.ctorParameters = () => [];
/** @nocollapse */ SiteModule.ɵmod = i0.ɵɵdefineNgModule({ type: SiteModule });
/** @nocollapse */ SiteModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SiteModule_Factory(t) { return new (t || SiteModule)(); }, imports: [[
            SiteRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SiteModule, { imports: [SiteRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SiteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    SiteRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2l0ZS5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9zaXRlL3NpdGUubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsaUJBQWlCLEVBQUMsTUFBTSx1QkFBdUIsQ0FBQzs7QUFPeEQsTUFBTSxPQUFPLFVBQVU7SUFDckI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixpQkFBaUI7aUJBQ2xCO2FBQ0Y7Ozs7OENBQ1ksVUFBVTttR0FBVixVQUFVLGtCQUpYO1lBQ1IsaUJBQWlCO1NBQ2xCO3dGQUVVLFVBQVUsY0FIbkIsaUJBQWlCO2tEQUdSLFVBQVU7Y0FMdEIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixpQkFBaUI7aUJBQ2xCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtTaXRlUm91dGluZ01vZHVsZX0gZnJvbSBcIi4vc2l0ZS1yb3V0aW5nLm1vZHVsZVwiO1xuXG5ATmdNb2R1bGUoe1xuICBpbXBvcnRzIDogW1xuICAgIFNpdGVSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBTaXRlTW9kdWxlIHtcbiAgY29uc3RydWN0b3IoKSB7fVxufVxuIl19